import { Injectable, inject } from '@angular/core';
import { ENDPOINTS } from '../../constants/endpoints';
import { HttpService } from '../http/http.service';
import { Observable } from 'rxjs';
import { BOGSetting, BOGSettingsSystemForm } from '../../models/bog-settings.model';
@Injectable({
  providedIn: 'root',
})
export class SystemFormService {
  private httpService = inject(HttpService);


  getBOGSettingSystemFormList(payload:any): Observable<BOGSettingsSystemForm[]> {
      const endpoint = `${ENDPOINTS.BOGSettingsSystemForm.Get}`;
      return this.httpService.get<BOGSettingsSystemForm[]>(endpoint,{bogFormId:payload.bogFormId},'json','body',true);
    }
    
    /**
     * Insert or update a link module
     */
    insertUpdateBOGSettingSystemForm(requestPayload: BOGSettingsSystemForm): Observable<BOGSettingsSystemForm> {
      const endpoint = `${ENDPOINTS.BOGSettingsSystemForm.InsertUpdate}`;
      return this.httpService.post<BOGSetting>(endpoint, requestPayload,'json','body',true);
    }
  
    /**
     * Delete a link module by ID
     */
    deleteBOGSettingSystemForm(id: number): Observable<any> {
      const endpoint = `${ENDPOINTS.BOGSettingsSystemForm.Delete}`;
      return this.httpService.delete<any>(endpoint,{id}, true);
    }

  
}